import React from 'react';

export default (optionIsCorrect, optionWasSelected) => {
    if (optionIsCorrect && optionWasSelected) {
        return <i className="material-icons float-start result-icon correct">check</i>;
    } else if (optionIsCorrect && !optionWasSelected) {
        return <i className="fa fa-hand-o-right float-start result-icon point-to-correct" />;
    } else if (!optionIsCorrect && optionWasSelected) {
        return <i className="material-icons float-start result-icon incorrect">close</i>;
    }
}
